import * as React from "react";
import { SVGProps } from "react";
const SvgLogoOpenai = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#logo-openai_svg__a)">
      <path
        d="M14.945 6.549a3.94 3.94 0 0 0-.347-3.274 4.107 4.107 0 0 0-4.4-1.934A4.065 4.065 0 0 0 7.15 0C5.375-.005 3.8 1.123 3.253 2.79A4.039 4.039 0 0 0 .552 4.725a3.99 3.99 0 0 0 .503 4.727 3.939 3.939 0 0 0 .347 3.274 4.106 4.106 0 0 0 4.4 1.934A4.062 4.062 0 0 0 8.85 16c1.777.004 3.353-1.125 3.9-2.793a4.039 4.039 0 0 0 2.7-1.934 3.991 3.991 0 0 0-.503-4.725ZM8.85 14.954a3.054 3.054 0 0 1-1.945-.694c.025-.013.068-.036.096-.053l3.229-1.84a.517.517 0 0 0 .265-.454V7.422l1.365.777a.047.047 0 0 1 .026.037v3.72c-.002 1.654-1.36 2.995-3.036 2.998Zm-6.529-2.751a2.952 2.952 0 0 1-.362-2.01l.096.057 3.229 1.84a.532.532 0 0 0 .53 0l3.942-2.246V11.4a.05.05 0 0 1-.019.042L6.473 13.3c-1.454.825-3.31.334-4.151-1.098Zm-.85-6.955a3.019 3.019 0 0 1 1.582-1.314l-.001.11v3.68c-.001.187.1.36.265.453l3.942 2.246-1.365.777a.049.049 0 0 1-.046.004l-3.265-1.86a2.98 2.98 0 0 1-1.112-4.095Zm11.213 2.575L8.742 5.577l1.364-.777a.049.049 0 0 1 .047-.004l3.264 1.86a2.978 2.978 0 0 1 1.112 4.096 3.027 3.027 0 0 1-1.581 1.314v-3.79a.516.516 0 0 0-.264-.453Zm1.358-2.017a4.353 4.353 0 0 0-.096-.057l-3.229-1.84a.532.532 0 0 0-.53 0L6.245 6.155V4.6a.05.05 0 0 1 .019-.041L9.528 2.7c1.454-.828 3.312-.335 4.15 1.1.355.606.483 1.315.363 2.005Zm-8.54 2.771L4.139 7.8a.047.047 0 0 1-.027-.037v-3.72c.001-1.656 1.363-2.998 3.041-2.997.71 0 1.397.246 1.943.694a2.276 2.276 0 0 0-.096.054L5.77 3.634a.516.516 0 0 0-.265.453l-.002 4.49ZM6.245 7 8 6l1.756 1v2L8 10 6.244 9V7Z"
        fill="#4D4D4D"
      />
    </g>
    <defs>
      <clipPath id="logo-openai_svg__a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLogoOpenai;
